import React from 'react';
import FilterBar from 'views/MockServices/FilterBar/FilterBar';
import MockGroupListBlazeTable from '../Groups/MockGroupListBlazeTable';
import { useDispatch, useSelector } from 'react-redux';
import { updateGroupFilter } from '../../../../store/mockServiceGroups/mockServiceGroupReducer';
import { Filter } from '../../../../store/mockServices/mockServiceTypes';
import { getMockServiceGroupList } from '../../../../store/mockServiceGroups/mockServiceGroupsActions';
import { PROVIDER_OPL } from '../../../../constants/bzm-constants';
import { ApplicationState } from '../../../../store/rootReducer';

const MockServiceGroups = () => {
  const dispatch = useDispatch();
  const groupFilter = useSelector((state: ApplicationState) => state.mockServiceGroup.filter);

  return (
    <div className={'card'}>
      <div className={'card-body'}>
        <FilterBar
          config={{ locationFilter: true, serviceFilter: false, statusFilter: true, searchFilter: true }}
          searchContext={'groups'}
          filter={groupFilter}
          onChange={(filter: Filter, source) => {
            dispatch(updateGroupFilter(filter));
            if (source !== 'search') {
              dispatch(getMockServiceGroupList());
            }
          }}
          locationsFilterBy={PROVIDER_OPL}
        />
        <MockGroupListBlazeTable />
      </div>
    </div>
  );
};

export default MockServiceGroups;
